import type { CityConfig } from "../city-template/types";

export const rosevilleConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Michigan DHHS Vital Records", href: "https://www.michigan.gov/mdhhs/adult-child-serv/informedconsent/vitalrecords", description: "Official Michigan vital records office in Lansing" },
    { label: "Marriage Licenses — Macomb County Clerk", href: "https://www.macombgov.org/clerk", description: "Macomb County Clerk — marriage license issuance" },
    { label: "Divorce Records — Macomb County Clerk", href: "https://www.macombgov.org/clerk", description: "Macomb County Clerk — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Michigan DHHS for online vital record orders" },
  ],
  city: "Roseville",
  state: "Michigan",
  stateAbbr: "MI",
  slug: "roseville",
  route: "/cities/roseville-mi",
  title: "Emergency Passport Roseville, MI — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Roseville, Michigan — as fast as 24 hours. Fast passport renewal and new passport applications for Roseville, Eastpointe, Clinton Township, and all Macomb County residents. Detroit Passport Agency alternative. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Roseville, MI",
  heroSubtitle: "Roseville travelers — from Macomb County commuters to families crossing the Blue Water Bridge to international travelers — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. Our couriers have direct access to the Detroit Passport Agency. A+ BBB rated courier service serving all of Macomb County and Metro Detroit.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Suburban%20Michigan%20neighborhood%20street%20scene%20with%20tidy%20homes%20and%20mature%20trees%20in%20a%20quiet%20residential%20community%2C%20Macomb%20County%20Michigan%20atmosphere%2C%20late%20summer%20afternoon%20with%20warm%20golden%20light%2C%20no%20text%20no%20people%2C%20clean%20suburban%20streets%20with%20well-maintained%20lawns%2C%20American%20suburban%20community%20photography%2C%20slight%20urban%20skyline%20visible%20in%20the%20distant%20background&width=1800&height=700&seq=roseville-mi-hero-001&orientation=landscape",
  heroImageAlt: "Roseville Michigan suburban residential neighborhood with tidy homes in Macomb County",
  geoPosition: "42.4973;-82.9371",
  geoPlacename: "Roseville, Michigan",
  lastModified: "2026-06-02",
  regionalAgency: {
    name: "Detroit Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Approximately 25 miles south of Roseville — appointments required, typically booked 2 weeks out",
  },
  nearbyCitiesZips: [
    { name: "Roseville", zips: "48066" },
    { name: "Eastpointe", zips: "48021" },
    { name: "Clinton Township", zips: "48035, 48036, 48038" },
    { name: "Warren", zips: "48088, 48089, 48091, 48092, 48093" },
    { name: "Sterling Heights", zips: "48310, 48311, 48312, 48313, 48314" },
    { name: "Mount Clemens", zips: "48043" },
    { name: "Saint Clair Shores", zips: "48080, 48081, 48082" },
    { name: "Fraser", zips: "48026" },
    { name: "Center Line", zips: "48015" },
    { name: "Grosse Pointe", zips: "48230, 48236" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to the Detroit Passport Agency — no appointment wait" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-global-line", title: "Blue Water Bridge Travel", desc: "Expertise for Canada border crossings from the Port Huron area" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — ship from any UPS or FedEx in Macomb County" },
  ],
  internalLinks: [
    { name: "Expedited passport in Sterling Heights, MI", route: "/cities/sterling-heights" },
    { name: "Emergency passport services in Warren, MI", route: "/cities/warren" },
    { name: "Michigan passport services overview", route: "/states/michigan" },
    { name: "Urgent passport services in Detroit, MI", route: "/cities/detroit" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Roseville, Michigan via secure registered courier and has direct access to the Detroit Passport Agency at 211 W. Fort St, Suite 1300. Our registered couriers hand-deliver your documents — meaning you get faster results without the appointment wait. Roseville residents can ship from any UPS or FedEx in Macomb County.",
  fpcOfficeDistance: "Serving Roseville, Eastpointe, Clinton Township, Warren, Sterling Heights, Mount Clemens, Saint Clair Shores, Fraser, and all of Macomb County",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Roseville and the greater Macomb County area. From the Gratiot Avenue corridor to the northern suburbs near Clinton Township, from the eastern border with Saint Clair Shores to the Detroit side — we serve all of Macomb County. Our courier service brings the Detroit Passport Agency directly to your doorstep.",
  nearbyCitiesIntro: "We serve Roseville and all Macomb County communities including Eastpointe, Clinton Township, Warren, Sterling Heights, Mount Clemens, Saint Clair Shores, Fraser, Center Line, and Shelby Township. We also serve travelers crossing the Blue Water Bridge to Canada.",
  howItWorksIntro: "Most Roseville travelers complete everything online and ship documents overnight. No waiting weeks for a passport agency appointment — our registered couriers handle the Detroit Passport Agency submission for you.",
  mistakesIntro: "Macomb County residents are busy commuters and families who often discover passport issues right before travel. Here are the most common passport mistakes we see from Roseville and Eastpointe travelers.",
  testimonialsIntro: "Roseville and Macomb County travelers — from auto industry workers to families visiting Canada to international vacationers — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Roseville, MI? Here are the most common ones we hear from Macomb County travelers.",
  statePageRoute: "/states/michigan",
  statePageName: "Michigan",
  dmvWebsite: "https://www.michigan.gov/sos",
  dmvLabel: "Michigan SOS — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct access to Detroit Passport Agency", "No appointment wait — we handle submission", "Perfect for business and family travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct access to Detroit Passport Agency", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Detroit Passport Agency (Self-Service)",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — typically 2 weeks out", "Life-or-death emergencies only", "Must appear in person downtown Detroit", "Full day commitment — 25+ miles each way"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Roseville and Macomb County travelers with immediate departure needs — as fast as 24 hours. Our couriers go directly to the Detroit Passport Agency. Perfect for last-minute business trips, family emergencies, and Canada border crossings.",
      bullets: ["24–48 hour turnaround available", "Registered courier to Detroit Passport Agency", "Blue Water Bridge and Canada travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Roseville adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Macomb County address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Roseville residents and families — including commuters, families, and new citizens.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Roseville and Macomb County residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Roseville-area families planning international vacations or visiting family abroad.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Roseville and Macomb County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Roseville MI", description: "Urgent passport processing for Roseville Michigan travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Roseville MI", description: "Fast passport renewal for Roseville Michigan residents with a previously-issued passport." },
    { name: "First-Time Passport Roseville MI", description: "New passport application services for Roseville Michigan residents applying for their first passport." },
    { name: "Child Passport Roseville MI", description: "Minor passport services for Roseville Michigan families with children under 16." },
  ],
  testimonials: [
    {
      name: "Jennifer M.",
      location: "Roseville, MI",
      rating: 5,
      text: "Family trip to Canada in 5 days and our daughter's passport was expired. Fast Passport Center got us her renewed passport in 3 days. We shipped from the UPS on Gratiot and it was seamless. Outstanding service for Macomb County families.",
      service: "Child Passport Renewal",
    },
    {
      name: "Robert T.",
      location: "Eastpointe, MI",
      rating: 5,
      text: "Business trip to Toronto with 48 hours notice. Fast Passport Center handled my emergency renewal in 36 hours. I never had to drive downtown to the agency — just shipped from the FedEx near me. Saved my business deal.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Sarah K.",
      location: "Clinton Township, MI",
      rating: 5,
      text: "First-time passport for our honeymoon cruise. The document review caught an issue with my birth certificate that the post office would have rejected. Fast Passport Center fixed it and got our passports in 6 days. Perfect.",
      service: "First-Time Passport",
    },
    {
      name: "Michael D.",
      location: "Roseville, MI",
      rating: 5,
      text: "Lost my passport the week before a trip to Mexico. Fast Passport Center got me a replacement in 48 hours. Their courier went straight to the Detroit agency. I was shocked how fast it was.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "roseville-1",
      name: "Detroit Passport Agency",
      type: "Regional Passport Agency",
      address: "211 W. Fort St, Suite 1300",
      city: "Detroit",
      state: "MI",
      zip: "48226",
      phone: "(313) 226-7110",
      hours: "Mon–Fri: 8:00 AM – 3:00 PM (by appointment only)",
      distance: "Approximately 25 miles south of Roseville — appointments typically booked 2 weeks out",
      website: "https://travel.state.gov/content/travel/en/passports/get-fast/passport-agencies.html",
      websiteLabel: "Schedule Appointment",
      notes: "Michigan's only regional passport agency. Serves travelers with international travel within 14 days (or 28 days with visa). Appointments are required — no walk-ins. Fast Passport Center couriers have direct access and can skip the appointment backlog.",
      icon: "ri-government-line",
    },
    {
      id: "roseville-2",
      name: "Roseville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "27300 Gratiot Ave",
      city: "Roseville",
      state: "MI",
      zip: "48066",
      phone: "(586) 777-8880",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Roseville — near I-94 and Gratiot Avenue",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Roseville acceptance facility. Convenient for Roseville, Eastpointe, and southern Macomb County residents. Appointments required — book 1–2 weeks in advance.",
      icon: "ri-mail-line",
    },
    {
      id: "roseville-3",
      name: "Eastpointe Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "21400 Gratiot Ave",
      city: "Eastpointe",
      state: "MI",
      zip: "48021",
      phone: "(586) 777-8890",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Eastpointe — approximately 3 miles west of Roseville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Eastpointe and the western Macomb County border. Call to confirm current passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "roseville-4",
      name: "Clinton Township Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "40700 Garfield Rd",
      city: "Clinton Township",
      state: "MI",
      zip: "48038",
      phone: "(586) 228-6100",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Clinton Township — approximately 6 miles north of Roseville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves northern Macomb County including Clinton Township, Mount Clemens, and Fraser. Book early — high demand during summer.",
      icon: "ri-mail-line",
    },
    {
      id: "roseville-5",
      name: "Sterling Heights Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "40111 Dodge Park Rd",
      city: "Sterling Heights",
      state: "MI",
      zip: "48313",
      phone: "(586) 247-4000",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Sterling Heights — approximately 10 miles north of Roseville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Macomb County residents including Sterling Heights, Shelby Township, and Utica. Book early — high demand during summer.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — typically 2 weeks out", fpc: "No — we handle the Detroit agency submission" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "In-Person Requirement", agency: "Yes — must drive 25+ miles to downtown", fpc: "No — ship from anywhere in Macomb County" },
    { feature: "Canada Border Expertise", agency: "No tailored advice", fpc: "Yes — Blue Water Bridge, Windsor, and Canada travel" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Macomb County commuters and families often discover passport issues right before travel. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-passport-line",
      title: "Using a Passport Card for Air Travel to Canada",
      description: "Many Macomb County residents crossing to Windsor use a passport card or enhanced license — but these are not valid for air travel. If you fly to Canada, you need a passport book.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo shops sometimes produce photos that meet ID requirements but not passport standards. Photos must be exactly 2x2 inches with a plain white or off-white background, taken within 6 months.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form for New Passports",
      description: "Missing signatures or incorrect form completion are the #1 rejection reasons at Macomb County acceptance facilities. Our document review catches these before submission.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking Canada Entry Requirements",
      description: "Canada has its own entry requirements separate from passport validity. Blue Water Bridge and Windsor travelers should verify current Canadian customs and immigration rules before crossing.",
    },
    {
      icon: "ri-time-line",
      title: "Assuming the Detroit Agency Has Walk-In Slots",
      description: "The Detroit Passport Agency requires appointments and is typically booked 2 weeks out. There are no same-day walk-in slots — plan ahead or use Fast Passport Center's courier service.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Macomb County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Roseville, Eastpointe, or Clinton Township." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier hand-delivers to the Detroit Passport Agency — no appointment wait required." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Macomb County address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Where is the nearest passport acceptance facility in Roseville, MI?", a: "The Roseville Post Office at 27300 Gratiot Ave is the primary acceptance facility in Roseville. The Eastpointe Post Office at 21400 Gratiot Ave and the Clinton Township Post Office at 40700 Garfield Rd are also nearby. All require appointments. Fast Passport Center eliminates the need for an in-person visit — our couriers handle everything." },
    { q: "How fast can I get an emergency passport in Roseville, MI?", a: "Fast Passport Center offers emergency passport processing in Roseville, Michigan in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Detroit Passport Agency — without you needing to drive 25+ miles to downtown Detroit." },
    { q: "Do I need a passport to cross the Blue Water Bridge to Canada?", a: "For air travel to Canada, yes — you need a passport book. For land crossings via the Blue Water Bridge, Ambassador Bridge, or Detroit-Windsor Tunnel, U.S. citizens can use a passport book, passport card, enhanced driver's license, or Trusted Traveler card. A passport book provides the most flexibility for all types of travel." },
    { q: "Can I get an expedited passport in the Macomb County suburbs?", a: "Absolutely. Fast Passport Center serves all of Macomb County including Roseville, Eastpointe, Clinton Township, Warren, Sterling Heights, Mount Clemens, Saint Clair Shores, and all surrounding communities. Our courier service works the same way everywhere — complete online, ship documents, we handle the rest." },
    { q: "What airports do Macomb County travelers use for international flights?", a: "Detroit Metro Wayne County Airport (DTW) in Romulus is the primary international departure hub for Macomb County residents, approximately 30–35 minutes from Roseville. DTW offers direct flights to London, Amsterdam, Tokyo, Mexico City, Cancun, and dozens of other international destinations. Windsor Airport (YQG) is a secondary option. Always verify your passport is valid for at least 6 months past your return date." },
    { q: "How much does an expedited passport cost in Roseville, MI?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Can Roseville residents get passport photos taken locally?", a: "Yes. Walgreens and CVS locations throughout Macomb County offer passport photos. UPS Stores, FedEx Office locations, and many AAA offices also provide passport photos. Photos must be 2x2 inches on a white or off-white background, taken within the last 6 months." },
    { q: "Does Fast Passport Center serve all of Macomb County?", a: "Yes. Fast Passport Center serves all of Macomb County including Roseville, Eastpointe, Clinton Township, Warren, Sterling Heights, Mount Clemens, Saint Clair Shores, Fraser, Shelby Township, and all surrounding communities. Our courier service is especially valuable for busy commuters who don't have time to drive to downtown Detroit." },
  ],
  photoLocations: [
    { name: "Walgreens — Roseville", address: "29500 Gratiot Ave, Roseville, MI 48066", hours: "Mon–Sun: 7AM–10PM" },
    { name: "CVS Pharmacy — Eastpointe", address: "18000 E 8 Mile Rd, Eastpointe, MI 48021", hours: "Mon–Sun: 8AM–9PM" },
    { name: "UPS Store — Clinton Township", address: "43300 Garfield Rd, Clinton Township, MI 48038", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "FedEx Office — Sterling Heights", address: "37100 Van Dyke Ave, Sterling Heights, MI 48312", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    { name: "Michigan SOS — Roseville", address: "29500 Little Mack Ave, Roseville, MI 48066", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Michigan Secretary of State office for driver's licenses, REAL ID, and vehicle registration. Reserve a spot online to avoid wait times.", featured: true },
    { name: "Michigan SOS — Clinton Township", address: "42700 Garfield Rd, Clinton Township, MI 48038", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Serves Clinton Township and northern Macomb County communities. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "DTW",
      name: "Detroit Metro Wayne County Airport",
      distance: "30–35 minutes from Roseville via I-94",
      address: "1 Detroit Metro Airport, Romulus, MI 48242",
      note: "Primary international hub for Metro Detroit. Delta Air Lines hub. Direct flights to London, Amsterdam, Tokyo, Paris, Mexico City, Cancun, and 40+ international destinations. Largest airport in Michigan.",
      flightUrl: "https://www.metroairport.com/",
      flightLabel: "DTW Flight Info",
      featured: true,
    },
    {
      code: "YQG",
      name: "Windsor Airport (Canada)",
      distance: "45–50 minutes from Roseville via I-94 and Ambassador Bridge",
      address: "3200 County Rd 42, Windsor, ON N9A 6J3, Canada",
      note: "Secondary option for Macomb County travelers crossing to Canada first. Smaller airport with limited international routes. Requires passport for air travel to/from Canada.",
      flightUrl: "https://www.yqg.ca/",
      flightLabel: "Windsor Airport Info",
      featured: false,
    },
  ],
};